(() => {
  'use strict';
  function init(root) {
    if (root.memoryCleanup) return;
    const board = root.querySelector('[data-memory-board]');
    board.tabIndex = -1;
    const feedback = root.querySelector('[data-memory-feedback]');
    const score = root.querySelector('[data-memory-score]');
    const movesLabel = root.querySelector('[data-memory-moves]');
    const restart = root.querySelector('[data-memory-restart]');
    const back = root.querySelector('[data-memory-back]');
    let products;
    try { products = JSON.parse(root.querySelector('[data-memory-products]').textContent); }
    catch { feedback.textContent = 'Het spel kan nu niet laden. Probeer het later nog eens.'; return; }
    if (products.length !== 6 || new Set(products.map(p => p.id)).size !== 6) {
      feedback.textContent = 'Het spel wordt klaargezet. Kom binnenkort nog eens spelen!';
      return;
    }
    let first = null, locked = false, moves = 0, found = 0, timer = null;
    const controller = new AbortController();
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const dealing = new Map();
    function finishDealing(card) {
      const animation = dealing.get(card);
      dealing.delete(card);
      card.classList.remove('is-dealing');
      animation?.cancel();
    }
    function finishAllDealing() {
      [...dealing.keys()].forEach(finishDealing);
    }
    function dealCards() {
      if (reducedMotion.matches) return;
      [...board.children].forEach((card, index) => {
        if (typeof card.animate !== 'function') return;
        const animation = card.animate([
          { opacity: 0, transform: 'translateY(20px) rotate(-2deg) scale(.96)' },
          { opacity: 1, transform: 'translateY(-2px) rotate(.3deg) scale(1)', offset: .75 },
          { opacity: 1, transform: 'none' }
        ], {
          duration: 460,
          delay: index * 50,
          easing: 'cubic-bezier(.16, 1, .3, 1)',
          fill: 'backwards'
        });
        card.classList.add('is-dealing');
        dealing.set(card, animation);
        animation.finished.then(() => finishDealing(card), () => finishDealing(card));
      });
    }
    reducedMotion.addEventListener('change', () => {
      if (reducedMotion.matches) finishAllDealing();
    }, { signal: controller.signal });
    board.addEventListener('focusin', event => {
      const card = event.target.closest('.memory-card');
      if (card) finishDealing(card);
    }, { signal: controller.signal });
    function start(animateIntro = false) {
      finishAllDealing();
      clearTimeout(timer);
      timer = null; first = null; locked = false; moves = 0; found = 0;
      score.textContent = '0 van 6'; movesLabel.textContent = '0';
      feedback.textContent = 'Zoek jij het eerste paar?';
      restart.textContent = 'Opnieuw beginnen'; restart.hidden = false;
      const deck = products.flatMap(product => [product, product]);
      for (let i = deck.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [deck[i], deck[j]] = [deck[j], deck[i]];
      }
      board.replaceChildren(...deck.map((product, index) => {
        const card = document.createElement('button');
        card.type = 'button'; card.className = 'memory-card';
        card.dataset.pair = String(product.id); card.dataset.title = product.title;
        card.dataset.position = String(index + 1);
        card.setAttribute('aria-label', `Kaartje ${index + 1}, omdraaien`);
        card.setAttribute('aria-pressed', 'false');
        const inner = document.createElement('span'); inner.className = 'memory-card-inner';
        inner.setAttribute('aria-hidden', 'true');
        const rear = document.createElement('span'); rear.className = 'memory-back';
        rear.append(back.content.cloneNode(true));
        const front = document.createElement('span'); front.className = 'memory-front';
        const img = document.createElement('img'); img.src = product.image; img.alt = '';
        img.width = 200; img.height = 200; img.draggable = false;
        img.addEventListener('error', () => {
          const fallback = document.createElement('span'); fallback.className = 'memory-fallback';
          fallback.textContent = product.title; img.replaceWith(fallback);
        }, { once: true });
        front.append(img); inner.append(rear, front); card.append(inner);
        return card;
      }));
      if (animateIntro) dealCards();
    }
    function reveal(card, open) {
      card.classList.toggle('is-open', open);
      card.setAttribute('aria-pressed', String(open));
      card.setAttribute('aria-label', open ? `Kaartje ${card.dataset.position}: ${card.dataset.title}` : `Kaartje ${card.dataset.position}, omdraaien`);
    }
    board.addEventListener('click', event => {
      const card = event.target.closest('.memory-card');
      if (!card || dealing.has(card) || locked || card === first || card.classList.contains('is-matched')) return;
      reveal(card, true);
      if (!first) { first = card; feedback.textContent = 'Welk kaartje hoort hierbij?'; return; }
      moves++; movesLabel.textContent = String(moves);
      if (first.dataset.pair === card.dataset.pair) {
        for (const match of [first, card]) {
          match.classList.add('is-matched'); match.setAttribute('aria-disabled', 'true');
          match.setAttribute('aria-label', `${match.getAttribute('aria-label')}, paar gevonden`);
        }
        first = null; found++; score.textContent = `${found} van 6`;
        feedback.textContent = found === 6 ? `Alles gevonden in ${moves} beurten! Dat was een mooi potje.` : 'Een paar gevonden. Goed bezig!';
        if (found === 6) restart.textContent = 'Nog een keer';
      } else {
        locked = true;
        feedback.textContent = 'Deze twee horen niet bij elkaar. Kijk nog even goed.';
        timer = setTimeout(() => {
          reveal(first, false); reveal(card, false); first = null; locked = false; timer = null;
          feedback.textContent = 'Probeer nog eens. Je hebt alle tijd.';
        }, 1300);
      }
    }, { signal: controller.signal });
    restart.addEventListener('click', () => { start(true); board.focus({ preventScroll: true }); }, { signal: controller.signal });
    root.memoryCleanup = () => { clearTimeout(timer); finishAllDealing(); controller.abort(); delete root.memoryCleanup; };
    start(true);
  }
  function scan(scope = document) { scope.querySelectorAll('[data-memory]').forEach(init); }
  scan();
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-memory]').forEach(root => root.memoryCleanup?.());
  });
})();
